import React from 'react';
import { ArrowUpDown } from 'lucide-react';
import {
  TableHead,
  TableHeader,
  TableRow,
} from '@/components/ui/table';

interface SortableHeaderProps {
  sortField: string;
  sortDirection: 'asc' | 'desc';
  onSortClick: (field: string) => void;
}

const TableHeaderComponent: React.FC<SortableHeaderProps> = ({
  sortField,
  sortDirection,
  onSortClick,
}) => {
  return (
    <TableHeader>
      <TableRow>
        <TableHead 
          className="w-[150px] cursor-pointer"
          onClick={() => onSortClick('date')}
        >
          <div className="flex items-center space-x-1">
            <span>Date</span>
            {sortField === 'date' && (
              <ArrowUpDown className={`h-4 w-4 ${sortDirection === 'asc' ? 'rotate-180' : ''}`} />
            )}
          </div>
        </TableHead>
        <TableHead 
          className="w-[120px] cursor-pointer"
          onClick={() => onSortClick('time')}
        >
          <div className="flex items-center space-x-1">
            <span>Time</span>
            {sortField === 'time' && (
              <ArrowUpDown className={`h-4 w-4 ${sortDirection === 'asc' ? 'rotate-180' : ''}`} />
            )}
          </div>
        </TableHead>
        <TableHead 
          className="cursor-pointer"
          onClick={() => onSortClick('title')}
        >
          <div className="flex items-center space-x-1">
            <span>Title</span>
            {sortField === 'title' && (
              <ArrowUpDown className={`h-4 w-4 ${sortDirection === 'asc' ? 'rotate-180' : ''}`} />
            )}
          </div>
        </TableHead>
        <TableHead 
          className="cursor-pointer"
          onClick={() => onSortClick('type')}
        >
          <div className="flex items-center space-x-1">
            <span>Type</span>
            {sortField === 'type' && (
              <ArrowUpDown className={`h-4 w-4 ${sortDirection === 'asc' ? 'rotate-180' : ''}`} />
            )}
          </div>
        </TableHead>
        <TableHead>Assigned To</TableHead>
        <TableHead>Location</TableHead>
        <TableHead>Notes</TableHead>
        <TableHead className="w-[100px]">Actions</TableHead>
      </TableRow>
    </TableHeader>
  );
};

export default TableHeaderComponent;
